<template>
  <iColumn gap="none" wrap="nowrap">
    <iColumn :max-width="480" gap="small">
      <iText>
        Design Mode
      </iText>
      <iRadioBar
        v-model="designVariantModel"
        :options="[
          {label: 'Desktop First', value: 'desktop'},
          {label: 'Mobile First', value: 'mobile'},
        ]"
      />
    </iColumn>
  </iColumn>
</template>

<script>
import { useConfigurationStore } from "%/stores/configuration-store";
import useFanPublicationStore from "%/stores/fan-publication-store";
import Publication from "%/dynamic-components/render-engine/classes-v2/publication";

export default {
  name: "DesignSettings",
  data() {
    return {
      designVariant: useConfigurationStore().designVariant,
    };
  },
  computed: {
    designVariantModel: {
      get() {
        return this.designVariant;
      },
      set(value) {
        this.designVariant = value;
        Publication.get(useFanPublicationStore().publicationId).designVariant = value;
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
